// Localização: frontend/src/api/financeiroApi.js
// API do Módulo Financeiro

import api from './api';

const BASE_URL = '/financeiro';

// ============================================================================
// CONTAS BANCÁRIAS
// ============================================================================

export const contaBancariaApi = {
    getAll: (params = {}) => {
        return api.get(`${BASE_URL}/contas-bancarias`, { params });
    },
    getById: (id) => {
        return api.get(`${BASE_URL}/contas-bancarias/${id}`);
    },
    create: (data) => {
        return api.post(`${BASE_URL}/contas-bancarias`, data);
    },
    update: (id, data) => {
        return api.put(`${BASE_URL}/contas-bancarias/${id}`, data);
    },
    delete: (id) => {
        return api.delete(`${BASE_URL}/contas-bancarias/${id}`);
    }
};

// ============================================================================
// CATEGORIAS
// ============================================================================

export const categoriaApi = {
    getAll: (params = {}) => {
        return api.get(`${BASE_URL}/categorias`, { params });
    },
    getById: (id) => {
        return api.get(`${BASE_URL}/categorias/${id}`);
    },
    create: (data) => {
        return api.post(`${BASE_URL}/categorias`, data);
    },
    update: (id, data) => {
        return api.put(`${BASE_URL}/categorias/${id}`, data);
    },
    delete: (id) => {
        return api.delete(`${BASE_URL}/categorias/${id}`);
    }
};

// ============================================================================
// SUBCATEGORIAS
// ============================================================================

export const subcategoriaApi = {
    getAll: (params = {}) => {
        return api.get(`${BASE_URL}/subcategorias`, { params });
    },
    getById: (id) => {
        return api.get(`${BASE_URL}/subcategorias/${id}`);
    },
    create: (data) => {
        return api.post(`${BASE_URL}/subcategorias`, data);
    },
    update: (id, data) => {
        return api.put(`${BASE_URL}/subcategorias/${id}`, data);
    },
    delete: (id) => {
        return api.delete(`${BASE_URL}/subcategorias/${id}`);
    }
};

// ============================================================================
// CONTAS A RECEBER
// ============================================================================

export const contaReceberApi = {
    getAll: (params = {}) => {
        return api.get(`${BASE_URL}/contas-receber`, { params });
    },
    getById: (id) => {
        return api.get(`${BASE_URL}/contas-receber/${id}`);
    },
    create: (data) => {
        return api.post(`${BASE_URL}/contas-receber`, data);
    },
    update: (id, data) => {
        return api.put(`${BASE_URL}/contas-receber/${id}`, data);
    },
    delete: (id) => {
        return api.delete(`${BASE_URL}/contas-receber/${id}`);
    },
    receber: (id, data) => {
        return api.post(`${BASE_URL}/contas-receber/${id}/receber`, data);
    },
    receberParcial: (id, data) => {
        return api.post(`${BASE_URL}/contas-receber/${id}/receber-parcial`, data);
    }
};

// ============================================================================
// CONTAS A PAGAR
// ============================================================================

export const contaPagarApi = {
    getAll: (params = {}) => {
        return api.get(`${BASE_URL}/contas-pagar`, { params });
    },
    getById: (id) => {
        return api.get(`${BASE_URL}/contas-pagar/${id}`);
    },
    create: (data) => {
        return api.post(`${BASE_URL}/contas-pagar`, data);
    },
    update: (id, data) => {
        return api.put(`${BASE_URL}/contas-pagar/${id}`, data);
    },
    delete: (id) => {
        return api.delete(`${BASE_URL}/contas-pagar/${id}`);
    },
    pagar: (id, data) => {
        return api.post(`${BASE_URL}/contas-pagar/${id}/pagar`, data);
    },
    pagarParcial: (id, data) => {
        return api.post(`${BASE_URL}/contas-pagar/${id}/pagar-parcial`, data);
    }
};

// ============================================================================
// TRANSAÇÕES
// ============================================================================

export const transacaoApi = {
    getAll: (params = {}) => {
        return api.get(`${BASE_URL}/transacoes`, { params });
    },
    getById: (id) => {
        return api.get(`${BASE_URL}/transacoes/${id}`);
    },
    mesclar: (data) => {
        return api.post(`${BASE_URL}/transacoes/mesclar`, data);
    },
    listarMesclagens: (params = {}) => {
        return api.get(`${BASE_URL}/transacoes/mescladas`, { params });
    },
    buscarMesclagem: (id) => {
        return api.get(`${BASE_URL}/transacoes/mescladas/${id}`);
    },
    desfazerMesclagem: (id) => {
        return api.delete(`${BASE_URL}/transacoes/mescladas/${id}`);
    }
};

// ============================================================================
// DASHBOARD
// ============================================================================

export const dashboardFinanceiroApi = {
    getResumo: () => {
        return api.get(`${BASE_URL}/dashboard/resumo`);
    },
    getFluxoCaixa: (params = {}) => {
        return api.get(`${BASE_URL}/dashboard/fluxo-caixa`, { params });
    },
    getPorCategoria: (params = {}) => {
        return api.get(`${BASE_URL}/dashboard/por-categoria`, { params });
    },
    getPrevisao: (params = {}) => {
        return api.get(`${BASE_URL}/dashboard/previsao`, { params });
    },
    getContasPagar: (params = {}) => {
        return api.get(`${BASE_URL}/dashboard/contas-pagar`, { params });
    },
    getContasReceber: (params = {}) => {
        return api.get(`${BASE_URL}/dashboard/contas-receber`, { params });
    }
};

// ============================================================================
// TRANSFERÊNCIAS
// ============================================================================

export const transferenciaApi = {
    getAll: (params = {}) => {
        return api.get(`${BASE_URL}/transferencias`, { params });
    },
    getById: (id) => {
        return api.get(`${BASE_URL}/transferencias/${id}`);
    },
    create: (data) => {
        return api.post(`${BASE_URL}/transferencias`, data);
    }
};

// ============================================================================
// EXPORT DEFAULT (objeto consolidado)
// ============================================================================

const financeiroApi = {
    contaBancaria: contaBancariaApi,
    categoria: categoriaApi,
    subcategoria: subcategoriaApi,
    contaReceber: contaReceberApi,
    contaPagar: contaPagarApi,
    transacao: transacaoApi,
    dashboard: dashboardFinanceiroApi,
    transferencia: transferenciaApi
};

export default financeiroApi;

